import {
    Message
} from "element-ui";
import {
    getFundCache
} from "../../api/common";
import checkResponseStatus from "../../utils/common"

export const searchBox = {
    data() {
        return {
            tableIndex: 0,
            previousIndex: "",
            firstSymbol: "",
            loading2: false,
            timeout: null,
            state: [
                "<div class='center_text_align'>请输入基金代码或者名称</div>"
            ],
        }
    },
    methods: {
        changeClass(event, index) {
            const self = this;
            if (index > 0) {
                event.currentTarget.className = "el-row searchHover";
                if (
                    self.previousIndex !== undefined &&
                    self.previousIndex !== ""
                ) {
                    self.previousIndex.className = "el-row";
                }
                self.previousIndex = event.currentTarget;
                self.firstSymbol =
                    self.$refs["cssClass" + index][0].$el.innerHTML;
            }
        },
        searchFundCache(queryString, index) {
            let self = this;
            self.tableIndex = index;
            self.searchPopoverVisible = true;
            if (self.$refs["items_" + self.tableIndex]) {
                self.$refs["items_" + self.tableIndex].$refs.popper.hidden = false;
                if (self.fundList[self.tableIndex]) {
                    self.fundList[self.tableIndex].symbol = queryString;
                }
            }
            if (queryString !== undefined && queryString.length > 0) {
                queryString = queryString.trim();
                clearTimeout(self.timeout);
                self.loading2 = true;
                self.timeout = setTimeout(() => {
                    getFundCache({
                            keyword: queryString
                        })
                        .then(response => {
                            let result = response.data;
                            if (result == undefined) {
                                Message({
                                    message: "抱歉，没有找到相关的内容！",
                                    type: "warning",
                                    duration: 2 * 1000
                                });
                                Message.close = function() {};
                            } else {
                                if (checkResponseStatus(result, self)) {
                                    self.symbolList = result.data;
                                    self.searchDataByAutoComplete(
                                        queryString
                                    );
                                }
                            }
                        })
                        .catch(x => {
                            Message({
                                message: "网络超时，请重新尝试！",
                                type: "error",
                                duration: 3 * 1000
                            });
                            Message.close = function() {};
                        })
                        .finally(r => {
                            self.loading2 = false;
                        });
                }, 500);
            }
        },
    }
}
